import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getConfig, isStaging } from '../config/environment';

const { firebase: firebaseConfig } = getConfig();

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Set persistence to LOCAL (survives browser restart)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error);
});

// Initialize Analytics only if supported
export const analytics = isSupported().then((yes) => (yes ? getAnalytics(app) : null));
export const storage = getStorage(app);
